
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable, OnDestroy, Output, EventEmitter } from '@angular/core'
//import { Http } from '@angular/http'
import { HttpClient } from '@angular/common/http'
import { AuthService } from './auth.service'
import { appStateProvider } from '../insa-providers/AppStateProvider'
import { appConfig } from '../../insaweb.config'
import { LocalizeService } from './localize.service';
import { SharedMethodsModule } from '../insa-custom-scripts/sharedMethods';
import { MainWindowSearchCriteriaModel } from '../insa-models/mainWindowSearchCriteria.model'
import { catchError } from 'rxjs/operators';
import { PartnerEmailModel } from '../insa-models';

@Injectable()
export class PartnerEmailService implements OnDestroy {

    private hostAddress = appConfig.insaServiceAddress;
    private servicesURL = "/PartnerEmails";
    private getEmailsUrl = "/GetEmails";
    private updateEmailsUrl = "/UpdatePartnerEmail ";

    partnerEmails: any;
    authServiceSubscription;
    stateSubscription;

    @Output() PartnerEmailsChangedEvent: EventEmitter<PartnerEmailModel[]> = new EventEmitter<PartnerEmailModel[]>(true);

    constructor(private _appStateProvider: appStateProvider, private http: HttpClient, private _authService: AuthService) {
        this.stateSubscription = _appStateProvider.subscribe(eventdata => this.initDataFetching(eventdata));

        this.authServiceSubscription = this._authService.LoggedInStatusChangedEmitter.subscribe((loggedIn) => {
            if (loggedIn.value === false) {
                this.clearData()
            }
        })
    }

    clearData() {
        this.partnerEmails = [];
    }

    initDataFetching(e) {
        if (!this._appStateProvider.fetchingPartnerEmails && !this.partnerEmails) {
            this.getPartnerEmails();
        }
    }

    getPartnerEmails() {
        // show a loading indicator
        this._appStateProvider.fetchingPartnerEmails = true;
        this.PartnerEmailsChangedEvent.emit(this.partnerEmails);

        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        // request
        let req = this.http.get(
            this.hostAddress + this.servicesURL + this.getEmailsUrl,
            { headers })
            .pipe(
                catchError(err => this.handleError(err, "Could not load emails")))
            //.map(res => res.json())
            .subscribe(data => {
                console.log(data);
                this.partnerEmails = data;
                this._appStateProvider.fetchingPartnerEmails = false;
                this.PartnerEmailsChangedEvent.emit(this.partnerEmails);
            })
        return req;
    };

    UpdatePartnerEmail(newEmail: PartnerEmailModel, jwt = '') {
        // shows a loading indicator
        this._appStateProvider.fetchingPartnerEmails = true;
        this.PartnerEmailsChangedEvent.emit(this.partnerEmails);
        
        let headers = this._authService.getAuthHeaders('application/json');
        let jwtquery = '';
        if (jwt != '') {
            jwtquery = '&jwt=' + encodeURIComponent(jwt);
        }
        else {
            jwtquery = '';
        }

        // request
        this.http.put(this.hostAddress + this.servicesURL + this.updateEmailsUrl, JSON.stringify(newEmail),
            { headers }).pipe(catchError(err => this.handleError(err, "Could not update partner emails.")),)
            .subscribe((res) => {
                console.log(res);
                this.getPartnerEmails();
            });
    }

    private handleError(error: any, message: string) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        SharedMethodsModule.addNotification("#notification", message, false);
        return observableThrowError(errMsg);
    }

    ngOnDestroy() {
        this.stateSubscription.unsubscribe();
        this.authServiceSubscription.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./app/insa-services/partner-email.service.ts